import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
export const zsyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录招商银行APP->顶部搜索【流水打印】->【流水打印】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "时间跨度选择【近一年】->输入专属邮件->确认并提交" },
      { imgs: [png3, png4] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "时间跨度选择【一年内】开启【展示交易对手信息】【展示完整卡号】【仅展示活期户流水】",
      },
    ],
  },
];
